<template>
  <b-container fluid>
    <b-row>
      <div class="iq-top-navbar">
        <div class="iq-navbar-custom">
          <nav class="navbar navbar-expand-lg navbar-light p-0">
            <div class="iq-navbar-logo d-flex justify-content-between">
                <img :src="orgData.org_profile_img" class="img-fluid navBarLogo mt-3" alt="logo">
            </div>
          </nav>
        </div>
      </div>

      <b-col md="8" lg="8" class="" v-if="operatingsystem == 'web'">
        <iq-card class="p-4 banner-text-left-card">
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <img :src="orgData.org_cover_img" style="width:100%" />
            <!-- Event Description -->
            <div class="col-12 mt-4">
              <span id="contactUsV1EventDescId" v-html="orgData.org_desc"></span>
            </div><!-- Event Description -->
          </template>
        </iq-card>
      </b-col>

      <b-col md="12" lg="8" class="" v-if="operatingsystem !== 'web'">
        <iq-card class="ban_card">
          <template v-slot:headerTitle>
          </template>
           <img v-if="!propOpenedInModal" :src="orgData.org_cover_img" style="width:100%" />
        </iq-card>
      </b-col>

      <b-col lg="4" style='background-color:#fff'>
        <div class="row p-3">
          <div class="col-12">
            <h3 class="mb-2">
              <span class="primary-color">{{orgData.org_name}}</span>
            </h3>
            <h3 class="mb-0">
              Complete Sign Up
            </h3>
            <p>
              Complete your profile
            </p>
          </div>
          <ValidationObserver ref="quickProfileForm">
            <form class="mt-4">
              <div v-bind:class = "(operatingsystem == 'web') ? 'gide_scroll_box row m-0' : 'gide_box row m-0'">
                <div class="form-group col-12">
                  <label for="yourFullName">Your full name <label class="primary-color font-size-16">*</label></label>
                  <ValidationProvider
                    name="Name"
                    rules="required|regex:^[a-zA-Z0-9 '.-]*$"
                    v-slot="{ errors }"
                  >
                    <input v-if="!userData.login_type || userData.login_type == 'email'" v-model="userName" type="text" minlength="3" maxlength="20" class="form-control mb-0" style="color:var(--iq-dark)" placeholder="Your Full Name">
                    <input v-else v-model="userName" type="text" class="form-control mb-0" placeholder="Your Full Name" minlength="3" maxlength="20" disabled>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <!-- Dont Show for Google & Apple Login -->
                <div class="form-group col-12" v-if="!userData.login_type || userData.login_type == 'email'">
                  <label for="exampleInputPassword1">Password <label class="primary-color font-size-16">*</label></label>
                  <ValidationProvider name="Password" rules="required|min:6|max:16" v-slot="{ errors }">
                    <input v-model="userPassword" type="password" class="form-control mb-0" id="exampleInputPassword1" placeholder="Password">
                    <span class="text-danger">{{ errors[0] }}</span>
                    <div><small>Should be between 6 and 16 characters</small></div>
                  </ValidationProvider>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-6 mb-3">
                  <label for="validation_country">Country Code</label>
                    <div class="flex-row">
                      <ValidationProvider
                        name="select one"
                        rules="required"
                        v-slot="{ errors }">
                          <select v-model="countryCodes" class="form-control w-100" id="validation_country">
                          <template class="w-100">
                            <option class="w-100" v-for="(country, index) of cvCountryOptions" :key="index+'1'" :value="country">
                              {{country.country_name}} (+ {{country.country_phone_code}})
                            </option>
                          </template>
                        </select>
                        <span class="text-danger"> {{ errors[0] }} </span>
                      </ValidationProvider>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-8 col-lg-6 mb-3">
                  <ValidationProvider
                    name="Enter contact number"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label for="validation_stu_contact_no">
                      Contact Number <label class="primary-color font-size-16">*</label>
                    </label>
                    <input v-model="userMobile" type="tel" minlength="3" maxlength="20" pattern="[0-9]" class="form-control" id="validation_stu_contact_no" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div>

                <!-- <div class="form-group col-12">
                  <label for="source">NOT SO SECRET CODE</label>
                  <input v-model="source" type="text" class="form-control mb-0" placeholder="If you have a code add it here or leave it blank">
                </div> -->

                <div class="form-group col-12" v-if="!userData.user_role || (userData.user_role && userData.user_role == 'USERROLE11114')">
                  <div id="studentRole" class="form-group col-12">
                    <div class="form-group">
                      <label for="Class / Degree">{{cvClassLabel}} <label class="primary-color font-size-16">*</label></label>
                      <multiselect
                        v-model="studentClass"
                        :options="cvClassOptions"
                        :placeholder="cvSelectBoxText +' '+ cvClassLabel"
                        label="class_name"
                        @select="classSelected"
                        track-by="class_name">
                      </multiselect>
                      <div v-show="showErrBox2" class="text-danger">
                        {{errMsg}}
                      </div>
                    </div>

                    <div class="form-group">
                      <label :for="cvSchoolAndCollegeLable">Choose Your {{cvSchoolAndCollegeLable}} <label class="primary-color font-size-16">*</label></label>
                      <multiselect
                          v-model="studentSchool"
                          :options="schoolOptionsWithAdd"
                          :placeholder="cvSelectBoxText + ' ' + cvSchoolAndCollegeLable"
                          track-by="org_id"
                          ref="multiselectschool"
                          @search-change="SearchSchoolList($event)"
                          :custom-label="customSchoolLabel"
                          @input="selectSchool"
                        >
                        <span slot="noResult">
                          {{ cvSchoolAndCollegeLable }} not found<br><hr>
                          <span @click="showAddSchool()" class="schoolAdd" varient="primary">
                            Click here to add your {{ cvSchoolAndCollegeLable }}
                          </span>
                        </span>
                      </multiselect>
                      <span><small>{{cvSchoolAndCollegeLable}} not found. <span @click="showAddSchool()" class="pointer">Click to Add {{ cvSchoolAndCollegeLable }}</span></small></span>

                      <!-- <select v-model="studentSchool" @change="onSchoolChange" class="form-control">
                        <option disabled value="">{{ cvSelectBoxText }} {{ cvSchoolAndCollegeLable }}</option>
                        <option v-for="school in cvSchoolOptions" :key="school.org_id" :value="school">
                           {{ schNameWithCityCountry(school) }}
                        </option>
                        <option @click="showAddSchool()" > Click here to add school </option>
                      </select>
                      -->
                      <div v-show="showErrBox1" class="text-danger">
                        {{errMsg}}
                      </div>
                    </div>

                    <template v-if="addSchoolShow">
                      <ValidationObserver ref="schoolForm">
                        <div class="form-group row">
                          <div class="col-md-12 col-lg-12 col-sm-12" v-for="(item, index) in cvSchoolFormWithLabel" :key="index">
                            <label :for="item.label">{{item.label}}</label>
                            <ValidationProvider :name="item.label" rules="required|min:2" v-slot="{ errors }">
                              <input v-model="schoolForm[item.key]" :type="item.type" class="form-control mb-0" :id="item.label">
                              <span class="text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                          </div>
                        </div>
                      </ValidationObserver>
                      <div class="form-group" style="margin-bottom:50px">
                        <button class="btn btn-primary" type="button" @click="addSchoolOrCollege" style="float: right;">
                          Add {{cvSchoolAndCollegeLable}}
                        </button>
                        <b-button type="button" @click="addSchoolShow = false" style="float: right; margin-right:10px">
                          Cancel
                        </b-button>
                      </div>
                    </template>
                    <div v-if="!studentClass.class_name || (typeof studentClass.class_name === 'number' && Number(studentClass.class_name) < 13)" class="col-12">
                      <div class="form-group">
                        <label for="Class">{{cvBoardLabel}} <label class="primary-color font-size-16">*</label></label>
                        <multiselect
                          v-model="studentBoard"
                          :options="cvBoardOptions"
                          :placeholder="cvSelectBoxText +' '+ cvBoardLabel"
                          label="board_name"
                          track-by="board_name">
                        </multiselect>
                        <div v-show="showErrBox3" class="text-danger">
                          {{errMsg}}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 p-0" v-else>
                      <div class="form-group col-12 p-0">
                        <label for="Degree Program">Degree Program <label class="primary-color font-size-16">*</label></label>
                        <ValidationProvider name="Degree"  v-slot="{ errors }" rules='required'>
                          <multiselect
                            v-model="degree_name"
                            :options="degreesOptionsList"
                            placeholder="Select Degree"
                            label="degree_name"
                            @select="degreeSelected"
                            track-by="degree_name">
                          </multiselect>
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="form-group col-12 p-0">
                        <label>Specialization <label class="primary-color font-size-16">*</label></label>
                        <ValidationProvider name="Specialization"  v-slot="{ errors }" rules='required'>
                          <multiselect
                            v-model="cour_name"
                            :options="degreeSpecializationList"
                            placeholder="Select Specialization"
                            label="course_name"
                            track-by="course_name">
                          </multiselect>
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-inline-block col-12 w-100">
                  <div class="custom-control custom-checkbox d-inline-block mt-2 pt-1">
                    <input type="checkbox" class="custom-control-input" id="customCheck1" v-model="tnc">
                    <label class="custom-control-label" for="customCheck1">I have read and accept the <a href="/content/Tnc" target="_blank">Terms of Use</a>
                    </label>
                    <div v-show="showTncErrBox" class="text-danger">
                      {{errMsg}}
                    </div>
                  </div>
                </div><!-- d-inline-block w-100 -->
                <div class="gide_button_fix">
                  <div class="SubmitBtn col-12">
                    <button type="button" class="btn btn-primary float-right" @click="userProfileComplete">
                      Submit
                    </button>
                  </div>
                </div>
              </div><!-- gide_scroll_box -->
            </form>
            <div class="sign-info" style="margin-top: 16px;">
              <span class="dark-color d-inline-block line-height-2">Go back to <router-link :to="{ path: 'login'}">Sign In</router-link>
              </span>
              <ul class="iq-social-media mt-4">
                <li>
                  <a href="https://www.facebook.com/highschoolmomsgroup" target="_blank"><i class="ri-facebook-box-line"></i></a>
                </li>
                <li>
                  <a href="https://twitter.com/hsminace" target="_blank"><i class="ri-twitter-line"></i></a>
                </li>
                <li>
                  <a href="https://www.instagram.com/highschoolmoms" target="_blank"><i class="ri-instagram-line"></i></a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/highschoolmoms/" target="_blank"><i class="ri-linkedin-line"></i></a>
                </li>
              </ul>
            </div>
            <div class="staticContent">
              <a href="/content/Tnc" target="_blank">Terms and Conditions</a>  | <a href="/content/PrivacyPolicy" target="_blank">Privacy Policy</a>
            </div>
          </ValidationObserver>
          <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
            <div v-html="toastMsg">
            </div>
          </b-toast>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<style lang="scss" scoped>
  @import url("../assets/css/custom.css");
  @import url("../assets/css/PriceSlider.css");
  .staticContent {
    margin-top: 20px;
    text-align: center;
    display:inline-flex;
    width: 100%;
    a{
      width: 100%;
    }
  }
  .SubmitBtn {
    width: 100%;
    padding-top: 13px;
    text-align: center;
  }
  .schoolAdd {
    color: var(--iq-primary);
    i {
      margin-right: 8px;
    }
  }
  .sign-info{
    border: 0px;
    padding:0px;
    margin:30px 0px;
  }
  @media screen and (min-width:576px){
    .gide_scroll_box{
      overflow: auto;
      height: calc(100vh - 320px);
      max-height: 550px;
      .form-group{
        width: 100%;
      }
    }
    .gide_box{
      overflow: auto;
      height: calc(100vh - 320px);
      max-height: 550px;
      .form-group{
        width: 100%;
      }
    }
  }
  .gide_button_fix{
    float: right;
    width: 100%;
  }
  .gide_scroll_box{
    .form-group{
      width: 100%;
    }
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { User } from "../FackApi/api/user.js"
import AutoLogin from "../Utils/autoLogin.js"
import { Organisations } from "../FackApi/api/organisation.js"
import ApiResponse from "../Utils/apiResponse.js"
import Multiselect from "vue-multiselect"
import config from "../Utils/config.js"
import { Countries } from "../FackApi/api/country.js"
import { degreeCourses } from "../FackApi/api/degreeCourse.js"

export default {
  name: "RegisterV1",
  components: {
    Multiselect
  },
  data: () => ({
    cvSelectBoxText: "Start typing ",
    cvSchoolAndCollegeLable: "School",
    cvBoardLabel: "Board",
    cvClassLabel: "Class / Degree",
    errMsg: "",
    showTncErrBox: false,
    showErrBox1: false,
    showErrBox2: false,
    showErrBox3: false,
    cvShowStudentInput: false,
    showToast: false,
    toastMsg: null,
    toastVariant: "default",
    toastTitle: "Registration",
    studentSchool: "",
    cvSchoolOptions: [],
    studentBoard: "",
    studentClass: "",
    cvClassOptions: config.ClassList,
    cvBoardOptions: config.BoardObjList,
    cvUniversityOptions: [],
    educatorSchool: "",
    userName: "",
    countryCodes: null,
    cvCountryOptions: [],
    userMobile: "",
    userRole: { user_role_id: "USERROLE11114" },
    userPassword: "",
    source: "",
    tnc: false,
    showPasswordField: false,
    cvUserRoleLabel: "You are a",
    operatingsystem: window.__DEVICE_OS__,
    device: "web",
    schoolForm: {
      org_name: "",
      org_locality: "",
      org_desc: "",
      org_board_offered: "",
      org_city: "",
      org_state: "",
      org_country: "",
      org_address: "",
      org_contact: "",
      org_website: ""
    },
    cvSchoolForm: [
      { key: "org_name", type: "text", label: "School Name" },
      { key: "org_locality", type: "text", label: "School Locality" },
      { key: "org_city", type: "text", label: "School City" },
      { key: "org_country", type: "text", label: "School Country" }
    ],
    addSchoolShow: false,
    disableUserRole: false,
    schLimit: 20,
    cvSchoolOptionsBackup: [],
    orgData: {
      id: 54238,
      org_id: "GIDE_ORG_1",
      user_id: "1",
      acc_id: "1",
      org_name: "GIDE.AI",
      type: "ORG",
      org_desc: `<h1><strong style="color: rgb(226, 38, 44);">GIDE.AI</strong><strong>: </strong>Your Gateway to Scholarships and Career Success</h1><p><strong style="color: rgb(230, 0, 0);">Brought to you by Asia's largest Student and Parent community - High School Moms (HSM)</strong></p><p>Access futuristic career assessment, profile building, test preparation, great scholarships, and career guidance all in one integrated experience.</p><p><br></p>`,
      org_website_email: null,
      org_admin_email: "admin@gide.ai",
      org_admision_email: "admissions@gide.ai",
      org_admission_requirement: null,
      org_top_alums: null,
      org_major_industries_around: null,
      org_clubs: null,
      org_college_type: null,
      org_city: null,
      org_country: null,
      org_founding_year: null,
      org_application_deadline: null,
      org_intake_count: null,
      org_intake_type: null,
      org_currency: null,
      org_avg_tuition_min: null,
      org_avg_tuition_max: null,
      org_scholarship_min: null,
      org_scholarship_max: null,
      org_tnc: 0,
      created_on: "2023-11-22T23:26:47.000Z",
      deleted: 0,
      country_id: null,
      org_profile_img: "https://web.gide.ai/img/GideWhiteNRed.2533ee45.jpeg",
      org_cover_img: "https://gide-assets.s3.amazonaws.com/GIDECover.White.png",
      org_state: null,
      org_uid: "",
      org_domain: "web.gide.ai",
      org_domain_is_validated: 99,
      country_name: null,
      currency_name: null,
      currency_code: null
    },
    schoolCheckRegx: /school|college|institute|academy|mandir|high|centre|Vidyapeeth|convent|vihar|house|vidhyapit|devshala|niketan|vidhyapith|Vidyapith|institution|Shiksha|bhavan|society|secondary|Vidhyalaya|peeth|guru|dps|Secondary|kendra|kendriya|senior|ashram|campus|sch|public|pub|the|Vidyalaya|sansthan/gmi,
    collegeCheckRegx: /college|university|institute of|institute|iit|iim|nit|iiit|polytechnic|business school|law school|engineering college|medical college|management institute|school of|faculty of|campus/i,
    propOpenedInModal: false,
    degree_name: null,
    cour_name: null,
    degreesOptionsList: [],
    degreeSpecializationList: []
  }),
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    sourceData () {
      return this.$store.getters["SourceTracker/getUserSource"]
    },
    saasOrgData () {
      return this.$store.getters["SaasOrgData/getSaasOrgData"]
    },
    schoolOptionsWithAdd () {
      return [
        ...this.cvSchoolOptions,
        {
          org_id: "__add_new__",
          name: "Click here to add school"
        }
      ]
    },
    cvSchoolFormWithLabel () {
      return this.cvSchoolForm.map(field => ({
        ...field,
        label: field.label.replace(/^School/, this.cvSchoolAndCollegeLable)
      }))
    }
  },
  beforeMount () {
    if (this.userData) {
      this.userEmail = this.userData.user_email
      this.userName = this.userData.user_name
      this.show_user_email = true
    }
    else {
      this.$router.push("/login")
    }
  },
  async mounted () {
    await this.getOrgDetails()
    history.pushState(null, null, location.href)
    window.onpopstate = function () {
      history.go(1)
    }

    // if sourceData is available then store in source else take user defined value to store in source
    if (this.sourceData) {
      this.source = this.sourceData
    }

    this.loadRequiredData()
  },
  methods: {
    /**
     * customSchoolLabel
     */
    customSchoolLabel (option) {
      if (option.org_id === "__add_new__") {
        return "Click here to add school"
      }
      return this.schNameWithCityCountry(option)
    },
    /**
     * getOrgDetails
    */
    selectSchool (selected) {
      if (selected && selected.org_id === "__add_new__") {
        this.showAddSchool()
        this.studentSchool = null
      }
    },
    /*eslint-disable */
    /**
     * getOrgDetails
     */
    async getOrgDetails () {
      try {
        // Do not get the org_details if running on localhost, for localdns we have to set the org_domain in DB
        if (process.env.VUE_APP_ENV == "local") {
          this.$store.dispatch("SaasOrgData/setSaasOrgData", this.orgData)
          return
        }

        const orgDomain = window.location.hostname
        if (this.saasOrgData) {
          // Found in Cache
          this.orgData = this.saasOrgData
        }
        else {
          const orgDetails = await Organisations.organisationView(this, this.orgId, orgDomain)
          if (!orgDetails.resp_status) {
            // set the details of GIDE_ORG_1 as default
            this.$store.dispatch("SaasOrgData/setSaasOrgData", this.orgData)
            return
          }

          this.orgData = orgDetails.resp_data.data
          // set the org data in local storage for saving in user table
          this.$store.dispatch("SaasOrgData/setSaasOrgData", this.orgData)

          // set the source for the user
          let source = this.orgData.org_uid
          if (this.sourceData) {
            source = this.orgData.org_uid + "_" + this.sourceData
          }

          this.$store.dispatch("SourceTracker/setCodeAction", source)
        }
      }
      catch (err) {
        console.error("Exception in getOrgDetails and err: ", err)
      }
    },
    schNameWithCityCountry ({ org_name, org_city, org_country }) {
      return `${org_name}${org_city ? ', '+org_city : ''}${org_country ? ', '+org_country : ''}`
    },
    /**
     * showAddSchool
     */
    showAddSchool () {
      this.addSchoolShow = true
      // this.$refs.multiselectschool.toggle()
    },
    /**
     * loadRequiredData
     */
    loadRequiredData () {
      this.countryDistinctList()
      const filter = {
        limit: this.schLimit,
        type: ["SCH"]
      }
      this.schoolList(filter)
    },
    /**
     * schoolList
     */
    async schoolList (filter) {
      let schoolResp = await Organisations.organisationList(this, filter, 1)
      if (schoolResp.resp_status) {
        this.cvSchoolOptions = Object.keys(schoolResp.resp_data.data).map((key)=> schoolResp.resp_data.data[key])
        this.cvSchoolOptionsBackup = [ ...this.cvSchoolOptions ]
      }
    },
    /**
     * SearchSchoolList
     */
    async SearchSchoolList (searchString) {
      if (!searchString || searchString.trim().length < 1) {
        this.cvSchoolOptions = [ ...this.cvSchoolOptionsBackup ]
        return
      }

      if (searchString.length < 3) {
        return
      }

      if (searchString.toLowerCase() === 'school' || searchString.toLowerCase() === 'schoo' || searchString.toLowerCase() === 'schoo' || searchString.toLowerCase() === 'sch') {
        this.toastMsg = 'Please enter your school name.'
        this.toastVariant = 'danger'
        this.showToast = true
        return
      }

      const filter = {
        search: searchString.trim()
      }

      if (this.cvSchoolAndCollegeLable === "School") {
        filter.type = ["SCH"]
      }
      else {
        filter.type = ["UNIV"]
      }

      let schoolResp = await Organisations.organisationListSearch(this, filter)
      if (schoolResp.resp_status) {
        this.cvSchoolOptions = schoolResp.resp_data.data
      }
    },
    /**
     * universityList
     */
    async universityList (searchString = null) {
      let filter = {}

      if (searchString && searchString.trim().length >= 2) {
        filter.search = searchString.trim()
      }

      filter.limit = 24
      filter.type = ["SCH"] // Get Only Schools
      filter.fields = [ "org_name", "org_city", "org_country", "org_admin_email" ]

      let universityResp = await Organisations.organisationListSearch(this, filter)
      if (universityResp.resp_status) {
        this.cvUniversityOptions = Object.values(universityResp.resp_data.data)
      }
    },
    /**
    /**
     * userProfileComplete
     */
    async userProfileComplete () {
      let valid = await this.$refs.quickProfileForm.validate()
      if (!valid) {
        return
      }

      let validRoleInput = this.validateRoleInput()
      if (!validRoleInput) {
        return
      }

      if (!this.tnc) {
        this.errMsg = 'Tnc is required'
        this.showTncErrBox = true
        return false
      }

      let userObj = {
        'user_id': this.userData.user_id,
        'user_email': this.userData.user_email,
        'user_mobile': `+${this.countryCodes.country_phone_code}` + this.userMobile,
        'user_mobile_country_code': `+${this.countryCodes.country_phone_code}`,
        'user_name': this.userName,
        'user_password': this.userPassword ? this.userPassword : false,
        'user_first_time_login': this.userData.user_first_time_login,
        'user_role': this.userData.user_role ? this.userData.user_role : this.userRole.user_role_id, // If role has already been allocated during the manage/invite user by the admin of the org then use that
        'student_school': this.studentSchool ? this.studentSchool.org_id : false,
        'student_school_name': this.studentSchool ? this.studentSchool.org_name : false,
        'user_city': this.studentSchool ? this.studentSchool.org_city : false,
        'user_country': this.countryCodes.id, // //country id in the country table
        'user_country_name': this.studentSchool ? this.studentSchool.org_city : false,
        'student_board': this.studentBoard ? this.studentBoard.board_name : false,
        'student_class': this.studentClass ? this.fixedClassName(this.studentClass.class_name) : false,
        'tnc': this.tnc,
        'module_obj_id': null,
        'module_type': null,
        'params': null,
        'device_id': window.__DEVICE_OS__,
        'fcm_push_token': "GIDE0000",
        'source' : this.source
      }

      if (this.userData.org_id) {
        userObj.org_id = this.userData.org_id
      }

      if (userObj.user_role === 'USERROLE11114') {
        if(!userObj.student_school) {
          // looks like student has not set the school info
          this.errMsg = `${this.cvSchoolAndCollegeLable} Info Missing`
          this.showErrBox1 = true
          return false
        }

        //student
        const params = {
          org_id: userObj.student_school,
          board_name: userObj.student_board,
          class_name: userObj.student_class
        }

        // adding degree and course object in params
        if (this.cour_name && Object.keys(this.cour_name).length > 0  && this.degree_name && Object.keys(this.degree_name).length > 0) {
          params.cour_name = this.cour_name
          params.degree_name = this.degree_name
        }

        userObj.module_obj_id = params.org_id
        userObj.module_type = "SCH"
        userObj.params = JSON.stringify(params)
      }

      let userProfileCompleteResp = await User.userProfileComplete(this, userObj)
      await ApiResponse.responseMessageDisplay(this, userProfileCompleteResp)
      if (!userProfileCompleteResp.resp_status) {
        this.toastVariant = 'danger'
      }
      else {
        /* check if the user is logging in for the first time, if yes and
           the user_role is USERROLE11116(org_admin) take him to the organisation edit page
        */

        if (this.userData.user_first_time_login == 1 && this.userData.user_role == "USERROLE11116") {
          let org = Object.keys(userProfileCompleteResp.resp_data.roles)[0]
          org = userProfileCompleteResp.resp_data.roles[org]

          if (org.udr_name == "Owner") {
            // set the deeplink to the edit page only if the user is owner of the org
            const deepLink = `/org_edit/ORG/${org.module_obj_id}`
            await this.$store.dispatch("DeepLink/setDeepLinkAction", deepLink)
          }
        }
        await AutoLogin.setUserLoginProfile(this, userProfileCompleteResp)
      }
    },
    /**
     * validateRoleInput
     */
    validateRoleInput () {
      if (this.userData.user_role && this.userData.user_role != "USERROLE11114") {
        // It looks like the user exists and has already been assigned a role. Most probably via the manage/Invite User Section in the organisation
        // To be checked only for UNIV, ORG roles not for student or parent
        return true
      }

      console.log("this.userRole.user_role_id", this.studentSchool, this.studentClass)
      console.log("this.userRole.user_role_id", this.userRole.user_role_id)
      if (this.userRole.user_role_id === 'USERROLE11114') {
        console.log("this.studentSchool", this.studentSchool)
        console.log("this.studentClass", this.studentClass)
        this.showErrBox1 = false
        this.showErrBox2 = false
        this.showErrBox3 = false
        this.errMsg = ""
        if (!this.studentClass) {
          this.errMsg = 'Please select a Class'
          this.showErrBox2 = true
          return false
        }
        else if (!this.studentSchool) {
          this.errMsg = 'Please select a school'
          this.showErrBox1 = true
          return false
        }
        else if ((!this.studentBoard || !this.studentBoard.board_name) && (typeof this.studentClass === 'number' && Number(this.studentClass) < 13)) {
          this.errMsg = 'Please select board name'
          this.showErrBox3 = true
          return false
        }
      }

      return true
    },
    /**
     * addSchoolOrCollege
    */
    async addSchoolOrCollege () {
      let valid = await this.$refs.schoolForm.validate()
      if (!valid) {
        return
      }

      if (this.cvSchoolAndCollegeLable === "School" && !this.schoolForm.org_name.match(this.schoolCheckRegx)) {
        this.showToast = true
        this.toastVariant = "danger"
        this.toastMsg = "Please enter valid school name"
        return
      }
      else if (this.cvSchoolAndCollegeLable === "College" && !this.schoolForm.org_name.match(this.collegeCheckRegx)) {
        this.showToast = true
        this.toastVariant = "danger"
        this.toastMsg = "Please enter valid College name"
        return
      }

      if (this.cvSchoolAndCollegeLable === "School") {
        this.schoolForm.type = "SCH"
      }
      else {
        this.schoolForm.type = "UNIV"
      }
      this.schoolForm.org_admin_email = process.env.VUE_APP_SUPPORT_EMAIL
      this.schoolForm.deleted = 3
      this.schoolForm.user_role = "USERROLE11114" // user is creating the organisation
      this.schoolForm.org_name += ", " + this.schoolForm.org_locality

      const schoolAddResp = await Organisations.organisationAdd(this, this.schoolForm);
      if (schoolAddResp.resp_status) {
        this.cvSchoolOptions.unshift(schoolAddResp.resp_data)
        this.studentSchool = schoolAddResp.resp_data
        this.addSchoolShow = false
      }

      ApiResponse.responseMessageDisplay(this, schoolAddResp, "Add School")
    },
    /**
     * countryDistinctList
     */
    async countryDistinctList () {
      try {
        let matchWithQuery = "distinct country"
        let countryDistinctListResp = await Countries.countryList(this, matchWithQuery)
        if (countryDistinctListResp && !countryDistinctListResp.resp_status) {
          return false
        }

        this.cvCountryOptions = countryDistinctListResp.resp_data.data
        if (this.userData && this.userData.country_id) {
          const findIndex = this.cvCountryOptions.findIndex(ele => ele.id === this.userData.country_id)
          if (findIndex >= 0) {
            this.countryCodes = this.cvCountryOptions[findIndex]
            if (this.userData.user_mobile) {
              let regx = new RegExp(this.countryCodes.country_phone_code, 'gm')
              this.userMobile = this.userData.user_mobile.replace(regx, '')
            }
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at countryDistinctList() and Exception:", err.message)
      }
    },
    /**
     * classSelected
     */
    classSelected (event) {
      let payload = {}
      if (event.class_name === "Bachelors / Undergraduate") {
        payload.degree_type = "Bachelors"
      }
      else if (event.class_name === "Masters / Postgraduate") {
        payload.degree_type = "Masters"
      }
      else if (event.class_name === "PhD") {
        payload.degree_type = "PhD"
      }

      if (payload.degree_type) {
        // updating lable
        this.cvSchoolAndCollegeLable = "College"

        // fetching degree list
        this.degreeCourseList(payload)

        // fething university list
        const filter = {
          limit: this.schLimit,
          type: ["UNIV"]
        }
        this.schoolList(filter)
      }
      else {
        // updating lable
        this.cvSchoolAndCollegeLable = "School"

        // fething school list
        const filter = {
          limit: this.schLimit,
          type: ["SCH"]
        }
        this.schoolList(filter)
      }
    },
    /**
     * degreeCourseList
     */
    async degreeCourseList (payload) {
      try {
        const degreeCourseResp = await degreeCourses.degreeCourseList(this, payload)
        if (!degreeCourseResp.resp_status) {
          ApiResponse.responseMessageDisplay(this, degreeCourseResp)
          return
        }
        if (degreeCourseResp.resp_data?.data) {
          if (payload.degree_name && payload.degree_type) {
            this.degreeSpecializationList = degreeCourseResp.resp_data.data
          }
          else {
            this.degreesOptionsList = degreeCourseResp.resp_data.data
          }
        }

      }
      catch (err) {
        console.error("Exception in degreeCourseList() and err: ", err.message)
      }
    },
    /**
     * degreeSelected
     */
    async degreeSelected (event) {
      let payload = {}
      if (event.degree_name) {
        payload.degree_name = event.degree_name
        payload.degree_type = event.degree_type
      }
      this.degreeCourseList(payload)
    },
    /**
     * fixedClassName
     */
    fixedClassName (className) {
      if (className === "Bachelors / Undergraduate") {
        return 13
      }
      else if (className === "Masters / Postgraduate") {
        return 14
      }
      else if (className === "PhD") {
        return 15
      }
      else {
        return Number(className)
      }
    }
  }
}
</script>
